import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

const QueryCookieSaver = () => {
    const { search } = useLocation();
/*   console.log(document.referrer)*/

    //  реферер
    useEffect(() => {
        const savedReferrer = Cookies.get('x-original-referrer');
        const currentReferrer = document.referrer;

        if (!savedReferrer && currentReferrer) {
            Cookies.set('x-original-referrer', currentReferrer, {
                secure: false,
            });
        }

        localStorage.setItem('x-original-referrer', JSON.stringify(currentReferrer));

    }, []);


    // query-параметры
    useEffect(() => {
        if (search && search.length > 1) {
            const cleanedSearch = search.startsWith('?') ? search.substring(1) : search;
            Cookies.set('x-original-query', cleanedSearch, { expires: 7 });
        } else {
            Cookies.remove('x-original-query');
        }
    }, [search]);

    return null;
};

export default QueryCookieSaver;
